export default "__VITE_ASSET__B3605Cjq__"